(function () {
  'use strict';
  var nav = document.querySelector('[data-tpl-craft-nav]');
  if (!nav) return;
  var links = nav.querySelectorAll('[data-craft-nav]');
  var sections = [];
  links.forEach(function (link) {
    var id = link.getAttribute('href').substring(1);
    var target = document.getElementById(id);
    if (target) sections.push({ id: id, el: target, link: link });
  });
  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var id = link.getAttribute('href').substring(1);
      var target = document.getElementById(id);
      if (target) {
        var targetPos = target.getBoundingClientRect().top + window.scrollY - 16;
        var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: targetPos, behavior: motionOk ? 'smooth' : 'auto' });
      }
    });
  });
  var ticking = false;
  var onScroll = function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var scrollY = window.scrollY;
      var viewH = window.innerHeight;
      var footer = document.querySelector('footer.footer');
      var hideNearFooter = false;
      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        hideNearFooter = footerRect.top < viewH + 80;
      }
      nav.classList.toggle('is-visible', scrollY > viewH * 0.8 && !hideNearFooter);
      var activeId = null;
      var triggerPoint = window.innerWidth <= 749 ? 80 : viewH * 0.4;
      for (var i = sections.length - 1; i >= 0; i--) {
        var rect = sections[i].el.getBoundingClientRect();
        if (rect.top <= triggerPoint) { activeId = sections[i].id; break; }
      }
      links.forEach(function (link) {
        var id = link.getAttribute('href').substring(1);
        var isActive = id === activeId;
        link.classList.toggle('is-active', isActive);
        if (isActive) { link.setAttribute('aria-current', 'true'); }
        else { link.removeAttribute('aria-current'); }
      });
      if (window.innerWidth <= 749 && activeId) {
        var activeLink = nav.querySelector('[data-craft-nav].is-active');
        if (activeLink) {
          var track = nav.querySelector('.tpl-craft-nav__track');
          var linkRect = activeLink.getBoundingClientRect();
          var trackRect = track.getBoundingClientRect();
          if (linkRect.left < trackRect.left || linkRect.right > trackRect.right) {
            var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            activeLink.scrollIntoView({ behavior: motionOk ? 'smooth' : 'auto', inline: 'center', block: 'nearest' });
          }
        }
      }
      ticking = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
